<template>
  <div>
    <pageTitle :pageTitle="$t('lang.k_332001')"></pageTitle>
    <!-- 有消息内容 -->
    <div v-if="msgDao.total > 0">
      <div class="message--title">
        <vh-button
          size="medium"
          round
          @click.prevent.stop="multiMsgDel"
          :disabled="ids && ids.length === 0"
        >
          {{ $t('lang.k_332002') }}
        </vh-button>
        <vh-button
          size="medium"
          round
          @click.prevent.stop="executeUseRead"
          :disabled="ids && ids.length === 0"
        >
          {{ $t('lang.k_332003') }}
        </vh-button>
      </div>
      <!-- 表格与分页 -->
      <div class="message-list">
        <table-list
          ref="msgTable"
          :isHandle="true"
          :manageTableData="msgDao.list"
          :tabelColumnLabel="msgTableColumn"
          :totalNum="msgDao.total"
          :tableRowBtnFun="tableRowBtnFun"
          width="114"
          min-height="auto"
          scene="msg_list"
          @getTableList="getMsgList"
          @changeTableCheckbox="checkMoreRow"
          @onHandleBtnClick="onHandleBtnClick"
        ></table-list>
      </div>
    </div>
    <!-- 无消息内容 -->
    <null-page null-type="nullData" v-else></null-page>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import NullPage from '../Error/nullPage.vue';
  import { sessionOrLocal } from '@/utils/utils';
  export default {
    name: 'msgList.vue',
    components: {
      PageTitle,
      NullPage
    },
    data() {
      return {
        msgDao: {
          total: 0,
          list: []
        },
        isHandle: false, // 是否有操作项
        userId: JSON.parse(sessionOrLocal.get('userId')),
        msgTableColumn: [
          {
            label: this.$t('lang.k_332004'),
            key: 'title',
            width: 'auto'
          },
          {
            label: this.$t('lang.k_332005'),
            key: 'created_at',
            width: 200
          },
          {
            label: this.$t('lang.k_332006'),
            key: 'msgTypeStr',
            width: 100
          },
          {
            label: this.$t('lang.k_332006'),
            key: 'msgStatusStr',
            width: 100
          }
        ],

        tableRowBtnFun: [
          {
            name: this.$t('lang.k_332007'),
            methodName: 'toMsgDetail'
          },
          {
            name: this.$t('lang.k_332008'),
            methodName: 'msgDel'
          }
        ],

        ids: []
      };
    },
    methods: {
      // 表格操作列回调函数， val表示每行
      onHandleBtnClick(val) {
        let methodsCombin = this.$options.methods;
        methodsCombin[val.type](this, val);
      },
      // 删除单条消息数据
      msgDel(that, { rows }) {
        that.confirmDelete(rows.msg_id, 2);
      },
      confirmDelete(ids, index) {
        this.$vhConfirm(this.$t('lang.k_332009'), this.$t('lang.k_332010'), {
          confirmButtonText: this.$t('lang.k_332011'),
          cancelButtonText: this.$t('lang.k_332012'),
          customClass: 'zdy-message-box',
          lockScroll: false,
          roundButton: true,

          cancelButtonClass: 'zdy-confirm-cancel'
        })
          .then(() => {
            this.$fetch('msgDel', {
              msg_id: ids
            })
              .then(res => {
                if (res && res.code === 200) {
                  this.$vhall_paas_port({
                    k: index === 1 ? 100835 : 100834,
                    data: {
                      business_uid: this.userId,
                      userId: '',
                      webinar_id: '',
                      refer: '',
                      s: '',
                      report_extra: {},
                      ref_url: '',
                      req_url: ''
                    }
                  });
                  this.$vhMessage.success(`${this.$t('lang.k_332013')}`);
                  this.ids = [];
                  this.$refs.msgTable.clearSelect();
                  this.getMsgList();
                } else {
                  this.$vhMessage({
                    type: 'error',
                    message: res.msg || this.$t('lang.k_332014')
                  });
                }
              })
              .catch(e => {
                console.log(e);
                this.$vhMessage({
                  type: 'error',
                  message: this.$t('lang.k_332014')
                });
              });
          })
          .catch(() => {});
      },
      // 跳转消息详情页
      toMsgDetail(that, { rows }) {
        that.$vhall_paas_port({
          k: 100833,
          data: {
            business_uid: that.userId,
            userId: '',
            webinar_id: '',
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        that.$router.push({
          path: `/other/msgDetail/${rows.msg_id}`
        });
      },
      // 获取消息中心列表数据
      getMsgList(pageInfo = { pageNum: 1, pos: 0, limit: 10 }) {
        if (pageInfo.pos == 0) {
          // 表格切换到第一页
          try {
            this.$refs.msgTable.pageInfo.pageNum = 1;
            this.$refs.msgTable.pageInfo.pos = 0;
          } catch (e) {
            console.log(e);
          }
        }
        this.$fetch('getMsgList', {
          pos: pageInfo.pos,
          limit: pageInfo.limit
        })
          .then(res => {
            let dao =
              res && res.code === 200 && res.data
                ? res.data
                : {
                    total: 0,
                    list: []
                  };
            (dao.list || []).map(item => {
              item.msgTypeStr = [
                '',
                this.$t('lang.k_332015'),
                this.$t('lang.k_332016'),
                this.$t('lang.k_332017')
              ][item['msg_type']]; // 1.财务消息2.用户消息3.活动消息
              item.msgStatusStr = [this.$t('lang.k_332018'), this.$t('lang.k_332019')][
                item['msg_status']
              ]; // 消息状态0未读1已读
            });
            this.msgDao = dao;
          })
          .catch(e => {
            console.log(e);
            this.msgDao = {
              total: 0,
              list: []
            };
          });
      },
      // 批量选择
      checkMoreRow(val) {
        console.log(val);
        this.ids = val.map(item => {
          return item.msg_id;
        });
      },
      // 标记为已读取
      executeUseRead() {
        console.log(this.ids);
        if (!(this.ids && this.ids.length > 0)) {
          this.$vhMessage({
            message: this.$t('lang.k_332020'),
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
        } else {
          this.$vhConfirm(this.$t('lang.k_332021'), this.$t('lang.k_332010'), {
            confirmButtonText: this.$t('lang.k_332011'),
            cancelButtonText: this.$t('lang.k_332012'),
            customClass: 'zdy-message-box',
            lockScroll: false,
            roundButton: true,

            cancelButtonClass: 'zdy-confirm-cancel'
          })
            .then(() => {
              this.$fetch('executeUseRead', {
                msg_id: this.ids.join(',')
              })
                .then(res => {
                  if (res && res.code === 200) {
                    this.$vhall_paas_port({
                      k: 100836,
                      data: {
                        business_uid: this.userId,
                        userId: '',
                        webinar_id: '',
                        refer: '',
                        s: '',
                        report_extra: {},
                        ref_url: '',
                        req_url: ''
                      }
                    });
                    this.$vhMessage({
                      message: this.$t('lang.k_332022'),
                      showClose: true,
                      // duration: 0,
                      type: 'success',
                      customClass: 'zdy-info-box'
                    });
                    this.ids = [];
                    this.$refs.msgTable.clearSelect();
                    // 重新从第一页查询
                    this.getMsgList();
                    // 通知右上角导航，需要更新未度消息
                    this.$EventBus.$emit('saas_vs_msg_count', true);
                  } else {
                    this.$vhMessage({
                      message: res.msg || this.$t('lang.k_332023'),
                      showClose: true,
                      // duration: 0,
                      type: 'error',
                      customClass: 'zdy-info-box'
                    });
                  }
                })
                .catch(res => {
                  console.log(res);
                  this.$vhMessage({
                    message: res.msg || this.$t('lang.k_332023'),
                    showClose: true,
                    // duration: 0,
                    type: 'error',
                    customClass: 'zdy-info-box'
                  });
                });
            })
            .catch(() => {});
        }
      },
      // 批量删除
      multiMsgDel() {
        if (!(this.ids && this.ids.length > 0)) {
          this.$vhMessage({
            message: this.$t('lang.k_332024'),
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
        } else {
          this.confirmDelete(this.ids.join(','), 1);
          // this.msgDel(this, {
          //   rows: {
          //     msg_id: this.ids.join(',')
          //   }
          // });
        }
      }
    },
    created() {
      this.getMsgList();
    },
    mounted() {
      this.$EventBus.$on('saas_vs_msg_num', this.getMsgList);
    }
  };
</script>
<style lang="less" scoped>
  .message-list {
    .layout--right--main();
    .min-height();
    .padding-table-list();
  }
  .message--title {
    margin-bottom: 24px;
  }
</style>
